import { ApiResourceLocation } from '../../data-access/types/api.location';
import { ReadonlyRepository } from '../abstraction';
import { ApiDataAccess } from '../../data-access/api.data-access';
import { Dictionary } from '../../types/dictionary';

export abstract class ReadonlyHttpApiListRepository<TResult, TParams> implements ReadonlyRepository<TResult, TParams> {

  protected constructor(protected dataAccess: ApiDataAccess,
              protected path: string | string[]) { }

  load(params: TParams): Promise<TResult> {
    const location: ApiResourceLocation = {
      path: this.path,
      queryParams: this.getLoadQueryParams(params),
      pathParams: this.getLoadPathParams(params),
    }
    const payload = this.getLoadPayload(params);
    return this.dataAccess.get(location, payload);
  }

  protected getLoadPathParams(params: TParams): Dictionary<unknown> | undefined {
    return undefined;
  }
  protected getLoadQueryParams(params: TParams): Dictionary<unknown> | undefined {
    return undefined;
  }
  protected getLoadPayload(params: TParams): unknown | undefined {
    return undefined;
  }
}
